import React from 'react';
import { Controller } from 'react-hook-form';
import DatePicker from 'react-multi-date-picker';
import Textarea from 'react-textarea-autosize';
import dayjs from 'dayjs';

import CustomInput from '../CustomInput';

import type { MemoryDataForm } from '../../types/forms/memorydataform';

interface MemoryAboutProps {
  memoryData: MemoryDataForm;
  register: Function;
  control: any;
  errors: any;
};

const MemoryAbout: React.FC<MemoryAboutProps> = ({ memoryData, register, control, errors }) => {
  const number = memoryData.timeline_id ? 2 : 3

  return (
    <div className="memory-about-container inner">
      <div className="memory-about-header">
        <div className="page-eyebrow">
          <wa-avatar initials={number.toString()} />
          About this memory
        </div>
      </div>
      <div className="memory-about wa-stack">
        <div className="wa-grid">
          <div className="memory-about-title">
            <label htmlFor="title">Memory title</label>
            <wa-input
              id="title"
              type="text"
              defaultValue={memoryData.title}
              {...register('title', { required: true })}
              className={errors.title ? 'invalid' : ''}
              hint={errors.title ? errors.title.message : ""}
            />
          </div>
          {!memoryData.timeline_id && (
            <div className="memory-about-dedicated-to">
              <label htmlFor="dedicatedTo">Who is this for?</label>
              <wa-input
                id="dedicatedTo"
                type="text"
                defaultValue={memoryData.dedicated_to}
                {...register('dedicated_to', { required: true })}
                className={errors.dedicated_to ? 'invalid' : ''}
                hint={errors.dedicated_to ? errors.dedicated_to.message : ""}
              />
            </div>
          )}
        </div>
        <div className="wa-grid">
          <div className="memory-about-date">
            <label htmlFor="date">Date of memory</label>
            <Controller
              control={control}
              name="date"
              defaultValue={memoryData.date}
              render={({ field }) => (
                <>
                  <DatePicker
                    render={<CustomInput {...field} className={errors.date ? 'invalid' : ''} />}
                    className="memory-about-date-picker"
                    value={dayjs(field.value).format('MM/DD/YYYY') || ''}
                    onChange={(date) => {
                      field.onChange(date?.isValid ? date.format('YYYY-MM-DD') : '');
                    }}
                    format="MM/DD/YYYY"
                  />
                </>
              )}
            />
            {errors.date && (
              <span className="error-message">{errors.date.message}</span>
            )}
            {memoryData.timeline_id && (
              <div className="memory-about-date-hint wa-gap-xs">
                <div>
                  <i className="fa-light fa-info-circle" />
                </div>
                <div>
                  Changing the date will reposition this memory on the timeline automatically.
                </div>
              </div>
            )}
          </div>
          <div className="memory-about-name">
            <label htmlFor="name">Your name</label>
            <wa-input
              id="name"
              type="text"
              defaultValue={memoryData.name}
              {...register('name', { required: true })}
              className={errors.name ? 'invalid' : ''}
              hint={errors.name ? errors.name.message : ""}
            />
          </div>
        </div>
        <div className="wa-grid">
          <div className="memory-about-content">
            <label htmlFor="content">Tell the story</label>
            <Textarea id="content" minRows={3} {...register('content')} defaultValue={memoryData.content} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default MemoryAbout;
